
import { CustomersBySerial } from '@ip6m/types';
import { Injectable } from '@nestjs/common';
import { ApiProperty } from '@nestjs/swagger';
import { AddressEntity } from '../../models/address.entity';
import { CustomerEntity } from '../../models/customer.entity';
import { GpsCoordinatesEntity } from '../../models/gpscoordinates.entity';
import { ServiceEntity } from '../../models/service.entity';
import { DatabaseService } from '../database/database.service';
import { LocationService } from '../location/location.service';


@Injectable()
export class ServiceService {
  

  constructor(private databaseService:DatabaseService,
      private locationService:LocationService
    ) {}

 
  async getServiceTypes()
  {
    
    return await this.databaseService.serviceTypeRepo.find()
  }

 
  async updateService(body,serviceId)
  {
   
   
    let serviceType= await this.databaseService.serviceTypeRepo.findOne(body.serviceTypeId)

   
    let service = await this.databaseService.serviceRepo.createQueryBuilder('service')
    .leftJoinAndSelect('service.location','location')
    .leftJoinAndSelect('location.gpsCoord','gpsCoord')
    .where({serviceId:serviceId}).getOne()

    let response =await this.locationService.newAddress(body).then(async (address)=>{

  
      service.location=address
      service.serviceType=serviceType
      service.ontSerialNum=body.ontSerialNum
      return 
    })
    
    await this.databaseService.serviceRepo.save(service)
    await this.databaseService.gpsCoordRepo.save(service.location.gpsCoord)
    await this.databaseService.locationRepo.save(service.location)

    console.log(service)
    let resp={
      serviceId: service.serviceId.toString(),
      customerId: service.customerId ? service.customerId.customerId.toString() : null,
      name: service.customerId ? service.customerId.name : null,
      zipcode: service.location ? service.location.zipcode : null,
      city: service ? service.location.street.city : null,
      street: service ? service.location.street : null,
      houseNum: service.location ? service.location.houseNum : null,
      gpsLatitude: service.location.gpsCoord? service.location.gpsCoord.gpsLatitude : null,
      gpsLongitude: service.location.gpsCoord? service.location.gpsCoord.gpsLatitude : null,
      ontSn: service.ontSerialNum,
      serviceType:service.serviceType,
      networkNode: null
    }
   
  
    return resp
  }
 

  async createNewService(customerId:number,body:NewServiceRequest)
  {
  
      let serviceType=await this.databaseService.serviceTypeRepo.findOne(body.serviceTypeId)
      let customer=await this.databaseService.customerRepo.findOne(customerId)

      let service=new ServiceEntity()
      service.serviceType=serviceType
      service.ontSerialNum=body.ontSerialNum
      service.customerId=customer
    
      
      let response =await this.locationService.newAddress(body).then(async (address)=>{

        service.location=address
       
       
        let result = await this.databaseService.serviceRepo.save(service).catch((error)=>{
          console.log(error)
          return error
        }).then((result)=>{
         
            if(result instanceof ServiceEntity)
            {
              console.log(body)
              return {
                serviceId: result.serviceId.toString(),
                customerId: result.customerId ? result.customerId.customerId.toString() : null,
                name: result.customerId ? result.customerId.name : null,
                zipcode: result.location ? result.location.zipcode : null,
                city: result ? result.location.street.city : null,
                street: result ? result.location.street : null,
                houseNum: result.location ? result.location.houseNum : null,
                gpsLatitude: result.location.gpsCoord? result.location.gpsCoord.gpsLatitude : null,
                gpsLongitude: result.location.gpsCoord? result.location.gpsCoord.gpsLatitude : null,
                ontSn: result.ontSerialNum,
                serviceType:result.serviceType,
                networkNode: null
              }
              
            }
            else return {error:true}
            
        })
        return result
      })


      return response 
      
  }


  async deleteService(serviceId)
  {
      let queryBuilder = this.databaseService.serviceRepo.createQueryBuilder('service').delete()
      .from(ServiceEntity)
      .where({serviceId:serviceId})

      let response = queryBuilder.execute().catch((error)=>{
        return error
      }).then((result)=>{
          if(result.affected==undefined)
          {
            return {
              error:true
            }
          }
          return {affected:result.affected}
      })

      return response
  }




  async getServices(customerId:string="ALL")
  {
    let queryBuilder = this.databaseService.serviceRepo
    .createQueryBuilder('service')
    .leftJoinAndSelect("service.customerId", "customer")
    .leftJoinAndSelect("service.location", "location")
    .leftJoinAndSelect("location.street", "street")
    .leftJoinAndSelect("street.city", "city")
    .leftJoinAndSelect("location.gpsCoord", "gps")
    .leftJoinAndSelect("service.serviceType", "serviceType")
    if(customerId!="ALL")
    {
      queryBuilder=queryBuilder.where({customerId:customerId})
    }

    let data = await queryBuilder.getMany()
    let resp={}
    
    for (let i = 0; i < data.length; i++) {
    
      
      resp[data[i].ontSerialNum.toUpperCase()] = {
        serviceId: data[i].serviceId.toString(),
        customerId: data[i].customerId ? data[i].customerId.customerId.toString() : null,
        name: data[i].customerId ? data[i].customerId.name : null,
        zipcode: data[i].location.zipcode,
        city: data[i].location.street.city,
        street: data[i].location.street,
        houseNum: data[i].location.houseNum,
        gpsCoords:data[i].location.gpsCoord,
        ontSn: data[i].ontSerialNum,
        serviceType:data[i].serviceType,
        apartment:data[i].location.apartment,
        networkNode: null
      }
      
    }
    console.log(resp)
    return resp

   
    
      
  
  
  }


 
  
  
  

  
}
export class NewServiceRequest{
  @ApiProperty()
  ontSerialNum: string
  @ApiProperty()
  serviceTypeId: number
  @ApiProperty()
  streetId:number
  @ApiProperty()
  cityId:number
  @ApiProperty()
  houseNum:string
  @ApiProperty()
  zipcode:string
  @ApiProperty()
  apartment:string
  @ApiProperty()
  gpsLatitude:number
  @ApiProperty()
  gpsLongitude:number


}
